import { render, staticRenderFns } from "./appCenter.vue?vue&type=template&id=41011558&scoped=true&"
import script from "./appCenter.vue?vue&type=script&lang=js&"
export * from "./appCenter.vue?vue&type=script&lang=js&"
import style0 from "./appCenter.vue?vue&type=style&index=0&id=41011558&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41011558",
  null
  
)

export default component.exports